/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import contentStatus from 'state/reducers/embedsState/embedManagementState/contentStatus/content_status';
import embedManagementStatus from 'state/reducers/embedsState/embedManagementState/embed_management_status'
import selectedEmbedStatus from 'state/reducers/embedsState/embedManagementState/selected_embed_status'
import imageStatus from 'state/reducers/embedsState/embedManagementState/image_status'
import formData from 'state/reducers/embedsState/embedManagementState/form_data'



/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE: ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const embedManagementStateRootReducer = combineReducers({
    contentStatus,
    imageStatus,
    selectedEmbedStatus,
    embedManagementStatus,
    formData
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedManagementStateRootReducer;
